/**
 * Prospection routes: the board, and the board with one prospect's window
 * open on top of it (the address the window puts in the bar, so back,
 * reload and a pasted link land on the same screen).
 */
define('prospectionRouter',[
  'require',
  'exports',
  'module',
  'marionette',
  'app',
  'jquery',
  'underscore',
  'itemPagesNameMixin'
], function (require, exports, module, Marionette, App, $, _, ItemPagesNameMixin) {
  'use strict';

  var ProspectionRouter = Marionette.AppRouter.extend({
    appRoutes: {
      'prospection': 'showBoard',
      // Before the :secId route — Marionette gives the first declared route the priority.
      'prospection/activity': 'showActivity',
      'prospection/:secId': 'showProspect'
    }
  });

  function setCurrentUrl(url) {
    App.currentUrl = url;
  }

  // Backing out of a window's URL onto the board: the window lives outside
  // the content region, so it has to be closed by hand.
  function closeProspectWindows() {
    require(['windows'], function (Windows) {
      _.each((Windows.views || []).slice(), function (windowView) {
        var id = windowView.id || '';
        if (id.indexOf('prospection:') === 0) {
          Windows.close(windowView);
        }
      });
    });
  }

  var API = {
    showBoard: function () {
      require([
        'prospectionBoardView',
        'contentShowController'
      ], function (BoardView, ContentShowController) {
        ContentShowController.showContent().done(function () {
          setCurrentUrl('prospection');
          closeProspectWindows();
          var view = new BoardView();
          App.regions.getRegion('main').currentView.getRegion('content').show(view);
          App.execute('set:active:nav:item', ItemPagesNameMixin.PROSPECTION);
        });
      });
    },

    showActivity: function () {
      require([
        'prospectionActivityView',
        'contentShowController'
      ], function (ActivityView, ContentShowController) {
        ContentShowController.showContent().done(function () {
          setCurrentUrl('prospection/activity');
          App.regions.getRegion('main').currentView.getRegion('content').show(new ActivityView());
          App.execute('set:active:nav:item', ItemPagesNameMixin.PROSPECTION);
        });
      });
    },

    showProspect: function (secId) {
      require([
        'prospectionBoardView',
        'prospectionWindowView',
        'contentShowController'
      ], function (BoardView, WindowView, ContentShowController) {
        ContentShowController.showContent().done(function () {
          setCurrentUrl('prospection');
          var region = App.regions.getRegion('main').currentView.getRegion('content');
          var current = region.currentView;
          // The board is already there when the window was opened by a click:
          // re-rendering it would throw away its scroll position and filters.
          if (!current || !(current instanceof BoardView)) {
            region.show(new BoardView());
          }
          App.execute('set:active:nav:item', ItemPagesNameMixin.PROSPECTION);
          WindowView.prototype.open(secId);
        });
      });
    }
  };

  App.on('prospection:show', function (secId) {
    App.navigate('prospection/' + secId, { trigger: true });
  });

  App.on('before:start', function () {
    new ProspectionRouter({
      controller: API
    });
  });

  module.exports = ProspectionRouter;
});

